import z from 'zod'
import { firestoreTimestamp, firestoreWriteTimestamp } from '../shared/schema'

export const schema = z.object({
  sectionId: z.string(),
  assignmentId: z.string(),
  slideDeckId: z.string(),
  slideDeckName: z.string(),
  slideDeckTeaser: z.string(),
  expiresAt: firestoreTimestamp.nullish(),
  userCount: z.number().int().nonnegative(),
  completedUserCount: z.number().int().nonnegative(),
  ungroupedUserCount: z.number().int().nonnegative(),
  groupCount: z.number().int().nonnegative(),
  hasQuizzes: z.boolean(),
  hasRubrics: z.boolean(),
  isGraded: z.boolean(),
})

export const writeSchema = schema.extend({
  assignedAt: firestoreWriteTimestamp,
  expiresAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    sectionId: '',
    assignmentId: '',
    slideDeckId: '',
    slideDeckName: '',
    slideDeckTeaser: '',
    expiresAt: null,
    userCount: 0,
    completedUserCount: 0,
    ungroupedUserCount: 0,
    groupCount: 0,
    isGraded: false,
    hasQuizzes: false,
    hasRubrics: false,
  })
)

type FirestoreSectionAssignmentOutputInferred = z.infer<typeof schema>

export type FirestoreSectionAssignmentOutputWrite = z.infer<typeof writeSchema>

export interface FirestoreSectionAssignmentOutput extends FirestoreSectionAssignmentOutputInferred {}
